import React, { useState, useMemo, useCallback } from 'react';
import Accordion from 'components/Accordion';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import Snackbar from 'components/DesignSystem/Snackbar';
import Searcher from 'components/DesignSystem/Searcher';
import RadioButton from 'components/DesignSystem/RadioButton';
import useGroupedLocations from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useGroupedLocations';

export default function Location() {
  const { availableLocations, selectedLocation, setLocation } = useGroupedLocations();
  const [search, setSearch] = useState('');

  const closeAccordion = useMemo(() => buildAccordionClickFunction('location-accordion'), []);
  const setLocationAndClose = useCallback((newLocation : number) => {
    setLocation(newLocation);
    closeAccordion();
  }, [setLocation, closeAccordion]);
  const pattern = new RegExp(search.split('').join('.*'), 'i');

  return (
    <Accordion.Item eventKey="location" id="location-accordion">
      <Accordion.Header>Local</Accordion.Header>
      <Accordion.Body>
        <Searcher value={search} onChange={(e) => setSearch(e.target.value)} />
        {availableLocations.length === 0 && (
          <Snackbar className="mt-2">
            Nenhum local disponível
          </Snackbar>
        )}
        {availableLocations.filter((location) => pattern.test(location.name)).map((location) => (
          <RadioButton
            key={location.id}
            label={location.name}
            checked={location.id === selectedLocation?.id}
            onChange={() => setLocationAndClose(location.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
